import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={props.width? `calc( ${props.width}/ 16 * 14 )`: 14}
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path fill="#00C9D6" d="M8 14 .206.5h15.588L8 14Z" />
  </svg>
)
export default SvgComponent
